import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {HospitalChain} from "../hospital.details";
import {localizationKey} from "../../../../i18n/i18n-model";

@Component({
    selector: "app-chain-section[chains][hospitalChain]",
    templateUrl: "./chain-section.component.html",
    standalone: false
})
export class ChainSectionComponent implements OnInit {

  selectedChainId: number | undefined = undefined;

  @Input()
  chains!: HospitalChain[];

  @Input()
  hospitalChain!: HospitalChain | undefined;

  @Input()
  settingChainDisabled!: boolean;

  @Output()
  chainChanged = new EventEmitter<number>();

  protected readonly localizationKey = localizationKey;

  ngOnInit(): void {
    this.selectedChainId = this.hospitalChain?.id;
  }

  onChainSelectionChange(chainId: number) {
    this.chainChanged.emit(chainId);
  }
}
